import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import {
  MY_FAVORITES_WATCH_LIST_ROUTE_PATH,
  MY_FAVORITES_SEARCHES_ROUTE_PATH,
  MY_FAVORITES_SHOPS_ROUTE_PATH,
  MY_FAVORITES_WATCH_LIST_ENDED_ROUTE_PATH,
  MY_FAVORITES_FEED_ROUTE_PATH,
} from '../components/shared/constants';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { FAVORITES_HUB, FavoritesHubPane, trackingSort } from '@reverbdotcom/commons/src/event_tracking/favorites';
import { Location } from 'history';

export function favoritesWatchListPageViewAttributes(location: Location) {
  return {
    pageName: MParticlePageName.ViewedFavoritesHubPage,
    currentView: FAVORITES_HUB,
    currentPane: location.pathname.includes('/ended') ? FavoritesHubPane.EndedWatches : FavoritesHubPane.LiveWatches,
    sort: trackingSort(location),
  };
}

export const MyFavoritesWatchListRoute = (
  <Route
    key="my_favorites_watch_list"
    path={MY_FAVORITES_WATCH_LIST_ROUTE_PATH}
    props={{
      clientSide: true,
      pageViewEvent: ({ location }) => (favoritesWatchListPageViewAttributes(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesWatchListLayoutWrapper));
    }}
  />
);

export const MyFavoritesWatchListEndedRoute = (
  <Route
    key="my_favorites_watch_list_ended"
    path={MY_FAVORITES_WATCH_LIST_ENDED_ROUTE_PATH}
    props={{
      ended: true,
      clientSide: true,
      pageViewEvent: ({ location }) => (favoritesWatchListPageViewAttributes(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesWatchListEndedLayoutWrapper));
    }}
  />
);

export const MyFavoritesSearchesRoute = (
  <Route
    key="my_favorites_searches"
    path={MY_FAVORITES_SEARCHES_ROUTE_PATH}
    props={{
      clientSide: true,
      pageViewEvent: {
        pageName: MParticlePageName.ViewedFavoritesHubPage,
        currentView: FAVORITES_HUB,
        currentPane: FavoritesHubPane.Searches,
      },
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesSearchesLayoutWrapper));
    }}
  />
);

export const MyFavoritesShopsRoute = (
  <Route
    key="my_favorites_shops"
    path={MY_FAVORITES_SHOPS_ROUTE_PATH}
    props={{
      clientSide: true,
      pageViewEvent: {
        pageName: MParticlePageName.ViewedFavoritesHubPage,
        currentView: FAVORITES_HUB,
        currentPane: FavoritesHubPane.Shops,
      },
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesShopsLayoutWrapper));
    }}
  />
);

export const MyFavoritesFeedRoute = (
  <Route
    key="my_favorites_feed"
    path={MY_FAVORITES_FEED_ROUTE_PATH}
    props={{
      clientSide: true,
      pageViewEvent: {
        pageName: MParticlePageName.ViewedFavoritesHubPage,
        currentView: FAVORITES_HUB,
        currentPane: FavoritesHubPane.Feed,
      },
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesFeedLayoutWrapper));
    }}
  />
);
